import { Map } from 'immutable';

import * as constants from './../constants';

const initialState = Map({
  timeoutId: '',
});

const desktopSessionLoadingReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case constants.SAVE_DESKTOP_SESSION_TIMEOUT:
      return state.set('timeoutId', payload);
    case constants.UNSUBSCRIBE_DESKTOP_SESSION: {
      const desktopSessionTimeoutId = state.get('timeoutId');
      clearTimeout(desktopSessionTimeoutId);
      return state.set('timeoutId', '');
    }
    default:
      return state;
  }
};

export default desktopSessionLoadingReducer;
export { initialState };
